export default __webpack_public_path__ + "static/media/1771.f97f2ed0.JPG";